import { Carousel } from '@one-thd/sui-carousel';
import { FulfillmentCard } from '../fulfillment-card/FulfillmentCard';
import { useCommonContext } from '../../contexts/common-context';
import { IDistributionView } from '../../models/active-orders';

export const FulfillmentsCarousel = ({
  activeDistributions,
  customerType,
  onCardClick,
  componentLocation,
}: {
  activeDistributions: IDistributionView[];
  customerType: string;
  onCardClick: (index: number) => void;
  componentLocation?: string;
}) => {
  const { isMobile } = useCommonContext();

  const slides = activeDistributions?.map((distribution: IDistributionView, index: number) => {
    const distributionKey = [
      distribution?.orderNumber,
      distribution?.distributionType,
      distribution?.distributionDate,
      distribution?.lineItems?.[0]?.lineId,
    ].filter(Boolean).join('-') || `active-distribution-${index}`;

    return (
      <FulfillmentCard
        distribution={distribution}
        customerType={customerType}
        key={distributionKey}
        onCardClick={() => onCardClick(index)}
      />
    );
  });

  return (
    <div
      className="sui-flex sui-flex-col sui-w-full sui-overflow-hidden sui-h-full"
      id="carousel-container"
    >
      <Carousel
        loop={false}
        type="peek"
        slidesPerView="auto"
        disableMargin
        slidesPerGroup={isMobile ? 1 : 2}
        spaceBetween={isMobile ? 8 : 16}
        shadow
        containerId="carousel-container"
        hideControls={!!isMobile}
        SwiperProps={isMobile ? { scrollbar: { hide: true } } : {}}
        breakpoints={{
          sm: {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
          },
          md: {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
          },
          lg: {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
          },
          xl: {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
          },
          '2xl': {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
          },
        }}
      >
        {slides}
      </Carousel>
    </div>
  );
};
